export const formatMultipleString = (string: string, count?: number) => {
  return `${count} ${string}${count !== 1 ? 's' : ''}`
}
